import { AnalyticService } from '../../apis/analytics';
import { FETCH_GLOBE_CHART } from '../actions.type';
import { FETCH_GLOBE_CHART_END } from '../mutations.type';

const initialState = {
  globeChart: {},
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_GLOBE_CHART](context, start_at) {
    try {
      const { data } = await AnalyticService.fetchGlobeChart(start_at);
      context.commit(FETCH_GLOBE_CHART_END, data);
      return data;
    } catch (error) {
      console.error('Error fetchGlobeChart:', error);
    }
  },
};

export const mutations = {
  [FETCH_GLOBE_CHART_END](state, data) {
    state.globeChart = data;
  },
};

export const getters = {
  globeChart(state) {
    return state.globeChart;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
